import { render, staticRenderFns } from "./info-work-duration.vue?vue&type=template&id=5c394873&"
import script from "./info-work-duration.vue?vue&type=script&lang=js&"
export * from "./info-work-duration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports